import api from '@/api/majorManagement'

const state = {

}

const actions = {
  getMajorManagementList (context, params) {
    return api.getMajorManagementList(params)
  },
  createMajor (context, params) {
    return api.createMajor(params)
  },
  updateMajor (context, params) {
    return api.updateMajor(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
